<template>
  <div>
    <Reportes />
  </div>
</template>

<script>
import Reportes from "../../../components/Reportes.vue";

export default {
  components: {
    Reportes,
  },
};
</script>
